import React from "react";

export const FormUIContext: any = React.createContext(null);
